//#region src/local-storage/get-local-item.ts
const getLocalItem = (key) => {
	const savedItem = localStorage.getItem(key);
	if (!savedItem) return;
	try {
		const parsedItem = JSON.parse(savedItem);
		if (parsedItem === null) {
			localStorage.removeItem(key);
			return;
		}
		return parsedItem;
	} catch {
		localStorage.removeItem(key);
	}
};

//#endregion
export { getLocalItem };